import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';

import { FilterOutlined as FilterOutlineIcon } from '@ant-design/icons';
import { Row, Col, Button } from 'antd';

import { Field, Form, Formik } from 'formik';
import type { FormikProps } from 'formik';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { MultipleTextFormField } from 'v2/components/Shared/FormFields/MultipleTextFormField';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import chargebackService from 'v2/services/chargeback';

import { initialValues } from './initialValues';
import type { IFilter } from './initialValues';
import FilterSchema from './validations';

const statusOptions: Array<{ label: string; value: number }> = [
  { label: 'Perdido', value: 7 },
  { label: 'Aguardando Documentação', value: 10 },
  { label: 'Em Análise', value: 20 },
  { label: 'Em Processamento', value: 1 },
  { label: 'Ganho', value: 3 }
];

const ChargebackFilter = () => {
  const [isLoading] = useObservable(() => chargebackService.isLoading(), []);

  const onSubmit = useCallback((values: IFilter, { setSubmitting }: FormikProps<IFilter>) => {
    chargebackService.setFilter({ ...values });
    setSubmitting(false);
  }, []);

  return (
    <Formik initialValues={initialValues} validationSchema={FilterSchema} onSubmit={onSubmit}>
      {({ isValid, isSubmitting, dirty, resetForm }: FormikProps<IFilter>) => (
        <Form id='chargeback-filter' className='mb-4'>
          <div>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Field label='Período' id='date' name='date' component={DateRangePickerFormField} />
              </Col>
              <Col xs={24} sm={12} md={8} xl={4}>
                <Field
                  id='customer_email'
                  name='customer_email'
                  fullWidth
                  label='E-mail do Cliente'
                  component={TextFormField}
                />
              </Col>
              <Col xs={24} sm={12} md={8} xl={4}>
                <Field
                  id='invoice_id'
                  name='invoice_id'
                  fullWidth
                  onlyNumbers
                  label='Fatura'
                  placeholder='Separar usando , (vírgula)'
                  component={MultipleTextFormField}
                />
              </Col>
              <Col xs={24} sm={12} md={8} xl={4}>
                <Field
                  id='id'
                  name='id'
                  multiple
                  options={statusOptions}
                  fullWidth
                  label='Status'
                  component={SelectFormField}
                />
              </Col>
              <Col xs={12} sm={12} md={8} xl={3} className='flex items-end md:pt-5'>
                <Button
                  id='clear-button'
                  loading={isLoading || isSubmitting}
                  disabled={!dirty || isSubmitting || isLoading}
                  block
                  type='text'
                  onClick={() => resetForm({ values: initialValues })}
                >
                  Limpar
                </Button>
              </Col>
              <Col xs={12} sm={12} md={8} xl={3} className='flex items-end md:pt-5'>
                <Button
                  id='basic-filter-button'
                  type='primary'
                  disabled={!isValid || isSubmitting || isLoading}
                  loading={isSubmitting || isLoading}
                  block
                  htmlType='submit'
                  icon={<FilterOutlineIcon className='mr-0 text-sm' />}
                >
                  Filtrar
                </Button>
              </Col>
            </Row>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ChargebackFilter;
